import Lang from "../../userPreferences/staticWords";
import DropDownList from "../sharedComponents/dropdown/dropdown";
import FileInput from "../sharedComponents/inputs/fileInput";
import Icon from "../sharedComponents/icons/fontawsomeIcons";
import { getCurrentLangFromRedux, getDir } from "../../algorithms/styleChanges";
const FileUploader = ({
  placeholderLTRWidth,
  placeholderRTLWidth,
  placeholder,
  FileOnChange,
  fileOnClick,
  containerStyle,
  fileIconColor,
  fileValue,
  dataSource,
  dropdownOnChange,
  dropdownId,
  dropdownOnFocus,
  uploadButtonOnChange,
  borderColor,
  fileTypeValue,
  contentStyle,
}) => {
  return (
    <div className={`d-flex ${containerStyle}`}>
      <div
        className={`d-flex justify-content-between align-items-center ${contentStyle}`}
        style={{
          border: `solid 1px ${borderColor ?? "#C7C7C9"}`,
          position: "relative",
        }}
      >
        <div
          style={{
            width:
              getDir(getCurrentLangFromRedux()) == "ltr"
                ? placeholderLTRWidth ?? 100
                : placeholderRTLWidth ?? 100,
            color: "#1a73e8",
            textAlign: "center",
            position: "absolute",
            top: -11,
            fontSize: 13,
            backgroundColor: "white",
            left: 0,
            right: 0,
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          {placeholder}
        </div>
        <div className="col-6 my-1">
          <FileInput
            iconName={"paperclip"}
            iconPrefix={"fas"}
            backgroundColor={fileIconColor ?? "#1a73e8"}
            name={"file"}
            message={fileValue ? Lang.change : ""}
            fileName={
              fileValue ? fileValue.name.substr(0, 35) : Lang.uploadAttachment
            }
            backgroundSize={30}
            size={18}
            onChange={FileOnChange}
            onClick={fileOnClick}
            iconColor={"white"}
          />
        </div>
        {dataSource ? (
          <div className="col-4 ">
            <DropDownList
              id={dropdownId}
              dataSource={dataSource}
              change={dropdownOnChange}
              border={false}
              placeholder={Lang.fileType}
              focus={dropdownOnFocus}
            />
          </div>
        ) : null}
        <div className="col-2 text-center my-2">
          <Icon
            color={
              fileTypeValue
                ? fileValue && fileTypeValue
                  ? "#1A73E8"
                  : "#C7C7C9"
                : fileValue
                ? "#1A73E8"
                : "#C7C7C9"
            }
            name={"cloud-upload-alt"}
            size={28}
            title={"uplaod this file"}
            iconPrefix={"fas"}
            onclick={uploadButtonOnChange}
          ></Icon>
        </div>
      </div>
    </div>
  );
};

export default FileUploader;
